import { Checkbox } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { useState } from 'react'

import type { DraftCreationProps } from '../draftCreationModal/types'
import { GlMapExcelUploadForm } from './GlMapExcelUploadForm'
import { GlMapHideOperationForm } from './GlMapHideOperationForm'

const HideOperationInputId = 'glMapIsHideOperation'

type Props = DraftCreationProps<'glMap'> & {
  formId: string
}

export const GlMapDraftCreationForm = ({
  formId,
  layer,
  block,
  initialValue,
  onStatusChanged,
}: Props) => {
  const translate = useTranslate()

  const isHideOperationFixed = initialValue?.value?.isHideOperation ?? false
  const [isHideOperation, setIsHideOperation] = useState(isHideOperationFixed)

  return (
    <>
      <Checkbox
        wrapperProps={{
          label: translate('glMapDraftForm.isHideOperation.label'),
          description: translate('glMapDraftForm.isHideOperation.description'),
        }}
        id={HideOperationInputId}
        checked={isHideOperation}
        onChange={setIsHideOperation}
      />
      {isHideOperation ? (
        <GlMapHideOperationForm
          formId={formId}
          layer={layer}
          block={block}
          initialValue={initialValue?.value}
          onStatusChanged={onStatusChanged}
        />
      ) : (
        <GlMapExcelUploadForm
          formId={formId}
          layer={layer}
          block={block}
          onStatusChanged={onStatusChanged}
        />
      )}
    </>
  )
}
